export const gameId = 21

export const color = 0x000000

export const backEndVersion = 2
